module.exports = __webpack_public_path__ + "img/kuangjiao_xc9.4aae8a74.jpg";